<template>
  <vuetify-dialog :ref="reference" :title="title" :button="button" :show="show" :closeable="closeable" @submit="submit">
    <div class="form-container d-flex flex-column justify-content-center align-items-center p-4">
      <div class="text-center">
        <h2 class="px-5 pt-4 pb-2">Thank you!</h2>
        <div class="subheading font-weight-light pt-3">Your account is all setup. We'll contact you shortly to discuss your landing page(s) requirements.</div>
      </div>
    </div>
    <div class="pa-2 mb-3 text-xs-center">
      <v-btn class="v-btn v-btn--large theme--dark success"
             target="_blank" @click="submit">
        {{button}}
      </v-btn>
    </div>
  </vuetify-dialog>
</template>
<script>
import VuetifyDialog from '@/components/VuetifyDialog';

export default {
  props: {
    title: { type: String, default: "" },
    button: { type: String, default: "Login" },
    closeable: { type: Boolean, default: false },
    reference: { type: String, default: "modal" },
    show: { type: Boolean, default: false },
  },
  components: {
    VuetifyDialog,
  },
  methods: {
    submit() {
      this.$emit('submit');
    }
  }
};
</script>
<style scoped>
  hr {
    margin-top: 0;
    margin-bottom: 0;
  }
  .v-list__tile__sub-title, .v-list__tile__title {
    white-space: normal;
    overflow: auto;
    text-overflow: unset;
  }
</style>


// WEBPACK FOOTER //
// src/pages/Signup/Thanks.vue